import React, { Component } from 'react';
import { connect } from 'react-redux'
import {Row,Col} from 'react-bootstrap'
import {addToCart,handleDetails} from '../../actions/cart_Action'
import styled from 'styled-components'
import {Modal} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import {ButtonContainer} from '../Button/Button'

 class Data extends Component{
   
  
  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false,
     
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  showData(id,title,price,img)
  {
    this.id=id;
    this.title=title;
    this.price=price;
    this.img=img;
  }
  handleShow() {
    this.setState({ show: true });
     
  }

    handleClick = (key)=>{
      
    this.props.addToCart(key);
       
    }
    handleDetails=(key)=>{
      this.props.handleDetails(key); 
    }
    render(){
      
      let itemList = this.props.inititems.map(item=>{
        if(item.category ==="drinks")
      // return console.log() 
            return(
        <> 
        
              
            <Col sm={4} className="card_complete">
            <ProductWrapper>               
           
             <div className="card custom-border" key={item.key}>
                
                        <div className="d-block w-100 img-container">
                        <Link to='/details'>
                            <img src={item.img} className="img-fluid card-img-top" alt="not found" style={{ width: "50rem", height: "12rem" }}
                             onClick ={()=>{
                                    
                              this.handleDetails(item.key)             
                              }}
                            />
                            </Link>
                              <button className="cart-btn" disabled={ item.inCart ?true:false } 
      
      onClick ={()=>{
        //console.log("you click me on cart")
         this.showData(item.id,item.title,item.price,item.img)
         this.handleShow()
        this.handleClick(item.key)

               
       }}>
      
      {item.inCart ?(<p className="text-capitalize mb-0" disabled>in the cart</p>) : <i className="fas fa-cart-plus"/>}
       </button> 
                         </div>
<Link to ='/details'>
                    <div className="card-body" 
                        onClick ={()=>{
                                    
                          this.handleDetails(item.key)             
                          }}
                    >
                
                <h4 className="card-title">
                  {item.p_name}     
                </h4>
                <h5>{item.price}</h5>
                <p className="card-text">{item.info}</p>
              </div>
            </Link>
              <div className="card-footer">
                <small className="text-muted">★ ★ ★ ★ ☆</small>
              </div>
              
                 </div>

                 </ProductWrapper>
                 </Col>
       
      </>           
            )
        })
      
        return(
            
            <div className="container">
                <h3 className="center">Our items</h3>

          <Modal id="cart-modal" show={this.state.show} onHide={this.handleClose}   {...this.props}
        
            centered>

          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title"><h5>Item added to Cart</h5></Modal.Title>
          </Modal.Header>
          <Modal.Body id="modal-body">
         

            <img align="center" src={this.img} className="img-fluid" alt="product" />
            
            <h5 align="center">{this.title} </h5> 
            <h5 className="text-muted" align="center">{this.price} </h5>
          
           </Modal.Body> 
          <Modal.Footer>
            <ButtonContainer variant="secondary" onClick={this.handleClose}>
              Continue Shopping
            </ButtonContainer>
            <Link to='/cart'>
            <ButtonContainer>
              Go to Cart              
           </ButtonContainer>
           </Link>
          </Modal.Footer>
        </Modal>

                <Row>
                
                    {itemList}
               
                </Row>
            </div>
            
        )
        
    }
}
const mapStateToProps = (state)=>{
    
    return {
      //items: state.items,
      inititems:state.inititems
    }
  }

  const mapDispatchToProps= (dispatch)=>{
    
    return{
        addToCart: (key)=>{dispatch(addToCart(key))},
        handleDetails: (key)=>{dispatch(handleDetails(key))},
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Data)

const ProductWrapper=styled.div`

&:hover{
    .card{
      border:0.04rem solid rgba(0,0,0,0.2);
      box-shadow:2px 2px 5px 0px rgba(0,0,0,0.2)
    }
    .card-footer{
      background:rgba(247,247,247);
    }
  }
  
.img-container{
    position:relative;
    overflow:hidden;
  }
  .card-img-top{
    transition:all 1s linear;
  }
  .img-container:hover .card-img-top{
    transform:scale(1.2);
  }
  
.cart-btn{
    position: absolute;
    right: 0;
    padding: 0.2rem 0.4rem;
    background: var(--lightBlue);
    border: none;
    color: var(--mainWhite);
    font-size: 1.4rem;
    border-radius: 0.5rem 0 0 0;  
    transform: translate(100%,100%);
    transition: all 1s linear; 
  }
  .img-container:hover .cart-btn{
    transform:translate(0,0);
  }
  .cart-btn:hover{
    color:var(--mainBlue);
    cursor:pointer;
  }

  
`;
